"use strict";
/**
 * File that contains the storage errors in es language.
 * Created on: Fri, 29 Jul 2022 01:14:29 GMT
 * Generated by "fto.js", file created by Jebbarbas.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const es = ['es', {
        "storage/unknown": {
            toDev: "Ocurrió un error desconocido.",
            toClient: "default"
        },
        "storage/object-not-found": {
            toDev: "No existe ningún objeto en la referencia deseada.",
            toClient: "default"
        },
        "storage/bucket-not-found": {
            toDev: "No se configuró ningún bucket para Cloud Storage.",
            toClient: "default"
        },
        "storage/project-not-found": {
            toDev: "No se configuró ningún proyecto para Cloud Storage.",
            toClient: "default"
        },
        "storage/quota-exceeded": {
            toDev: "Se superó la cuota del bucket de Cloud Storage. Si estás en el nivel sin costo, deberás actualizar a un plan pagado. Si estás en un plan pagado, comunícate con el personal de asistencia de Firebase.",
            toClient: "Limite diario del plan gratuito excedido, vuelve mañana."
        },
        "storage/unauthenticated": {
            toDev: "El usuario no se autenticó. Vuelve a intentarlo después de realizar la autenticación.",
            toClient: "Debe iniciar sesión para relizar esta acción."
        },
        "storage/unauthorized": {
            toDev: "El usuario no está autorizado para realizar la acción deseada. Consulta las reglas de seguridad para asegurarte de que sean correctas.",
            toClient: "No tiene el permiso suficiente para realizar esta acción."
        },
        "storage/retry-limit-exceeded": {
            toDev: "Se superó el límite de tiempo máximo permitido para una operación (de carga, descarga, eliminación, etc.). Vuelve a subirlo.",
            toClient: "Se excedió el tiempo de espera."
        },
        "storage/invalid-checksum": {
            toDev: "El archivo del cliente no coincide con la suma de verificación del archivo que recibió el servidor. Vuelve a subirlo.",
            toClient: "Error en el archivo, intenta volver a subirlo."
        },
        "storage/canceled": {
            toDev: "El usuario canceló la operación.",
            toClient: "Operación cancelada por el usuario."
        },
        "storage/invalid-event-name": {
            toDev: "Se proporcionó un nombre de evento no válido. El modo debe ser uno de los siguientes: 'running', 'progress' o 'pause'.",
            toClient: "default"
        },
        "storage/invalid-url": {
            toDev: "Se proporcionó una URL no válida a refFromURL(). Debes usar el formato gs://bucket/object o https://firebasestorage.googleapis.com/v0/b/bucket/o/object?token=&ltTOKEN>",
            toClient: "default"
        },
        "storage/invalid-argument": {
            toDev: "El argumento que se pase a put() debe ser un arreglo de tipo 'File', 'Blob' o 'UInt8'. El argumento que se pase a putString() debe ser una string sin procesar 'Base64' o 'Base64URL'.",
            toClient: "default"
        },
        "storage/no-default-bucket": {
            toDev: "No se estableció ningún bucket en la propiedad storageBucket de tu configuración.",
            toClient: "default"
        },
        "storage/cannot-slice-blob": {
            toDev: "Ocurre generalmente cuando hubo un cambio en el archivo local (se borró, se volvió a guardar, etc.) Intenta volver a subirlo después de verificar que el archivo no haya cambiado.",
            toClient: "Error en el archivo, intenta volver a subirlo."
        },
        "storage/server-file-wrong-size": {
            toDev: "El archivo del cliente no coincide con el tamaño del archivo que recibió el servidor. Vuelve a subirlo.",
            toClient: "Error en el archivo, intenta volver a subirlo."
        },
    }];
exports.default = es;
